import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { HorizontalTabs } from "@/components/HorizontalTabs";
import { PolicyOverview } from "./policy-overview";
import { PolicyStats } from "./policy-stats";
import { PolicyAcknowledgementTable } from "./policy-acknowledgement-table";
import { withBranding } from "@/utils/helper";

export const PolicySummaryView = () => {
  const { t } = useTranslation("company");
  usePageTitle(
    withBranding(t("company:policies_settings.policy_summary_page_title")),
  );
  const tabsConfig = [
    {
      id: "overview",
      value: "overview",
      label: t("company:policies_settings.overview"),
      content: <PolicyOverview />,
    },
    {
      id: "acknowledgement-tracking",
      value: "acknowledgement-tracking",
      label: t("company:policies_settings.acknowledgement_tracking"),
      content: <PolicyAcknowledgementTable />,
    },
  ];

  return (
    <div className="flex flex-col gap-4 flex-1">
      <PolicyStats />
      <HorizontalTabs tabConfig={tabsConfig} />
    </div>
  );
};
